import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { User, AuthResponse } from '@/types/auth'
import { authService } from '@/services/auth.service'

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User | null>(null)
  const token = ref<string | null>(localStorage.getItem('jwt'))
  const isInitialized = ref(false)

  const isAuthenticated = computed(() => !!token.value && !!user.value)

  const setAuthData = (authResponse: AuthResponse): void => {
    token.value = authResponse.jwt
    user.value = authResponse.user
    localStorage.setItem('jwt', authResponse.jwt)
    localStorage.setItem('user', JSON.stringify(authResponse.user))
  }

  const login = async (googleToken: string): Promise<void> => {
    const response: AuthResponse = await authService.exchangeCodeForToken(googleToken)
    setAuthData(response)
  }

  const logout = async (): Promise<void> => {
    authService.logout()
    token.value = null
    user.value = null
    isInitialized.value = false
    localStorage.removeItem('jwt')
    localStorage.removeItem('user')
  }

  const initAuth = async (): Promise<void> => {
    if (isInitialized.value) return
    
    const storedToken = localStorage.getItem('jwt')
    const storedUser = localStorage.getItem('user')
    
    if (storedToken && storedUser) {
      try {
        token.value = storedToken
        user.value = JSON.parse(storedUser)
        
        // Verificar se o token ainda é válido
        const currentUser = await authService.getCurrentUser()
        user.value = currentUser
        localStorage.setItem('user', JSON.stringify(currentUser))
        
        isInitialized.value = true
      } catch (error) {
        console.error('Token inválido ou expirado:', error)
        await logout()
      }
    } else {
      isInitialized.value = true
    }
  }

  return {
    user,
    token,
    isAuthenticated,
    isInitialized,
    setAuthData,
    login,
    logout,
    initAuth
  }
})